var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "BuildABox" }, [
    _vm.validUser && _vm.hasProducts
      ? _c(
          "div",
          { staticClass: "build-wrapper no-scrollbar" },
          [
            _c("div", { staticClass: "builder-content-wrapper" }, [
              _vm.currentStep > 1
                ? _c(
                    "div",
                    {
                      staticClass: "storefront-header",
                      style: _vm.storefrontHeaderConfig
                        ? "background-color:" + _vm.storefrontHeaderConfig.color
                        : ""
                    },
                    [
                      _vm.showCustomHeader
                        ? _c("div", { staticClass: "custom-header" }, [
                            _c("img", {
                              attrs: { src: _vm.storefrontHeaderConfig.image }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                style:
                                  _vm.storefrontHeaderConfig &&
                                  _vm.storefrontHeaderConfig.textColor
                                    ? "color:" +
                                      _vm.storefrontHeaderConfig.textColor
                                    : ""
                              },
                              [_vm._v(_vm._s(_vm.storefrontHeaderConfig.text))]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentPage > 0
                ? _c(
                    "div",
                    {
                      staticClass: "builder-experience-container no-scrollbar",
                      attrs: { id: "scroll-container" }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.currentStep > 1,
                              expression: "currentStep > 1"
                            }
                          ],
                          staticClass: "full-view-header",
                          class: _vm.currentStep == 1 ? "step2" : "",
                          attrs: { id: "scroll-header" }
                        },
                        [
                          _c("div", [
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.changePage(false)
                                  }
                                }
                              },
                              [_vm._v("< back")]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "happybox-button white border filters",
                              class: [
                                !_vm.selectedCardsOccasions.includes("View All")
                                  ? "selected"
                                  : "",
                                _vm.currentStep > 2 ? "card" : ""
                              ],
                              on: {
                                click: function() {
                                  _vm.$refs.cardComponent.showFilters()
                                }
                              }
                            },
                            [
                              !_vm.selectedCardsOccasions.includes("View All")
                                ? _c("img", {
                                    staticClass: "purple",
                                    attrs: {
                                      src:
                                        "https://cdn.shopify.com/s/files/1/1363/8433/files/filter_purple.svg?v=1723141690"
                                    }
                                  })
                                : _c("img", {
                                    staticClass: "normal",
                                    attrs: {
                                      src:
                                        "https://cdn.shopify.com/s/files/1/1363/8433/files/filters.png?v=1722266559"
                                    }
                                  }),
                              _vm._v("\n            Filters \n            "),
                              !_vm.selectedCardsOccasions.includes("View All")
                                ? _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.selectedCardsOccasions.length
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "steps" }, [
                            _vm._v(
                              "\n            STEP " +
                                _vm._s(_vm.currentStep) +
                                " OF 3"
                            ),
                            _c("span", { staticClass: "dots" }, [_vm._v(":")]),
                            _c("span", { staticClass: "legend" }, [
                              _vm._v(_vm._s(_vm.currentCopy))
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "dot",
                                class: _vm.currentStep == 1 ? "current" : ""
                              },
                              [
                                _c("span", {
                                  class: 1 <= _vm.currentStep ? "selected" : ""
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "dot",
                                class: _vm.currentStep == 2 ? "current" : ""
                              },
                              [
                                _c("span", {
                                  class: 2 <= _vm.currentStep ? "selected" : ""
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "dot",
                                class: _vm.currentStep == 3 ? "current" : ""
                              },
                              [
                                _c("span", {
                                  class: 3 <= _vm.currentStep ? "selected" : ""
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value:
                                    "Save your selections for 24 hours. Inventory subject to availability",
                                  expression:
                                    "'Save your selections for 24 hours. Inventory subject to availability'"
                                }
                              ],
                              staticClass: "leave-builder",
                              on: { click: _vm.leaveBuilder }
                            },
                            [
                              _vm._v(_vm._s(_vm.headerText) + " "),
                              _c("img", {
                                attrs: {
                                  src:
                                    "https://cdn.shopify.com/s/files/1/1363/8433/files/save_cart.svg?v=1722005665",
                                  alt: "save cart"
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.currentPage == 1
                        ? _c("Page3", {
                            on: {
                              leavebuilder: _vm.leaveBuilder,
                              changepage: function($event) {
                                return _vm.changePage($event)
                              },
                              gostep: function($event) {
                                return _vm.goStep($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentPage == 2
                        ? _c("Page4", {
                            on: {
                              changepage: function($event) {
                                return _vm.changePage($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("Page5", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.currentPage > 2,
                            expression: "currentPage > 2"
                          }
                        ],
                        ref: "cardComponent",
                        attrs: {
                          user: _vm.user,
                          sender: _vm.sender,
                          currentPage: _vm.currentPage
                        },
                        on: {
                          changepage: function($event) {
                            return _vm.changePage($event)
                          },
                          gotoaddonselection: _vm.goToAddonSelection,
                          opencart: function($event) {
                            return _vm.openCart()
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("SideCartNew", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentStep > 1,
                  expression: "currentStep > 1"
                }
              ],
              ref: "outSideCart",
              attrs: {
                isSticking: _vm.isSticking,
                step: _vm.currentStep,
                fromCard: _vm.fromCard
              },
              on: {
                changepage: function($event) {
                  return _vm.changePage($event)
                },
                bundle: _vm.bundle,
                gostep: function($event) {
                  return _vm.goStep($event)
                }
              }
            }),
            _vm._v(" "),
            _vm.oosIsActive
              ? _c("OOSPopUp", {
                  attrs: {
                    oosProducts: _vm.noStockItems,
                    firstStateProducts: _vm.currentStateSelectedAddons,
                    fromSavedCart: _vm.fromSavedCart,
                    fromCurated: _vm.fromCurated
                  },
                  on: {
                    goback: _vm.closeOOSPopUp,
                    continuesaved: _vm.continueSaved,
                    continuecurated: _vm.continueCurated
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.extraInputs.length > 0 &&
            Object.keys(_vm.submittedInputs).length === 0
              ? _c("ExtraInputModal")
              : _vm._e(),
            _vm._v(" "),
            _vm.nonCustomProducts.length == 0 && _vm.currentPage == 1
              ? _c("div", { staticClass: "global-spinner-container" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "global-spinner" })
                ])
              : _vm._e()
          ],
          1
        )
      : _c("div", { staticClass: "login-page" }, [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/LOGO_sparkle-01.png?v=1726671236",
              alt: "Happy Box Logo"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "login-container" },
            [
              _vm._m(1),
              _vm._v(" "),
              !_vm.loading
                ? [
                    _vm.isLoggedIn && _vm.loggedUser
                      ? _c("div", { staticClass: "logged-container" }, [
                          _vm._v(
                            "\n        You are logged in as " +
                              _vm._s(_vm.loggedUser.email) +
                              " "
                          ),
                          _c("br"),
                          _vm._v(
                            " which does not have access to this collection.\n        "
                          ),
                          _c("div", { staticClass: "signup-prompt" }, [
                            _c("p", [
                              _c(
                                "a",
                                {
                                  attrs: { href: "#" },
                                  on: { click: _vm.logout }
                                },
                                [_vm._v("Logout")]
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isLoggedIn && _vm.loggedUser
                      ? _c("div", { staticClass: "separator" }, [
                          _c("span", [_vm._v("OR LOGIN AS")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        staticClass: "login-form",
                        on: {
                          submit: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.handleLogin($event)
                          }
                        }
                      },
                      [
                        _c(
                          "md-field",
                          { class: _vm.messageClass },
                          [
                            _c("label", [_vm._v("Username")]),
                            _vm._v(" "),
                            _c("md-input", {
                              attrs: { id: "email", required: "" },
                              model: {
                                value: _vm.email,
                                callback: function($$v) {
                                  _vm.email = $$v
                                },
                                expression: "email"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "md-error" }, [
                              _vm._v("Invalid username or password")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "md-field",
                          { class: _vm.messageClass },
                          [
                            _c("label", [_vm._v("Password")]),
                            _vm._v(" "),
                            _c("md-input", {
                              attrs: {
                                type: "password",
                                id: "password",
                                required: ""
                              },
                              model: {
                                value: _vm.password,
                                callback: function($$v) {
                                  _vm.password = $$v
                                },
                                expression: "password"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "md-error" }, [
                              _vm._v("Invalid username or password")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "actions" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "login-button happybox-button green border",
                              attrs: {
                                disabled: _vm.loginDisabled,
                                type: "submit"
                              }
                            },
                            [_vm._v("Login")]
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isSSO
                      ? _c("div", { staticClass: "separator" }, [
                          _c("span", [_vm._v("OR USE")])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSSO
                      ? _c("div", { staticClass: "alternative-login" }, [
                          _c(
                            "button",
                            {
                              staticClass: "google-sign-in-button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.login("google")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          Sign in with Google\n        "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "google-sign-in-button microsoft",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.login("microsoft")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          Sign in with Microsoft\n        "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                : _c("div", { staticClass: "login-spinner" }, [
                    _c("div", { staticClass: "global-spinner" })
                  ])
            ],
            2
          )
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("amazing gifts "),
      _c("br", { staticClass: "mobile" }),
      _vm._v(" are loading...")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-header" }, [
      _c("h2", [_vm._v("Login to Happy Box")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }